import { Fragment } from 'react';
import moment from 'moment';
import { isNil } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'semantic-ui-react';

import MaybeTranslation from 'components/MaybeTranslation';

// STYLES
import { ConnectedMetadataWrapper, ConnectedMetadataText } from 'components/Inputs/Inputs.styles';

import styled from 'styled-components';
import colors from 'styles/colors';

const StyledCarIcon = styled(Icon)`
  &&&& {
    font-size: 1.9em;
    margin-right: 0px;

    &.ok {
      color: ${colors.ok};
    }

    &.warning {
      color: ${colors.interrupt};
    }

    &.error {
      color: ${colors.error};
    }
  }
`;

function ConnectedCarIcon() {
  return <StyledCarIcon className="car-connected ok" />;
}

function InterruptedCarIcon() {
  return <StyledCarIcon className="car-connected warning" />;
}

function DisconnectedCarIcon() {
  return <StyledCarIcon className="car-disconnected error" />;
}

function CarIcon({ hasValue, isValid, isConnected, isManuallyEdited }) {
  if (isConnected) {
    return hasValue && isValid && !isManuallyEdited ? <ConnectedCarIcon /> : <InterruptedCarIcon />;
  }
  return <DisconnectedCarIcon />;
}

function MetadataText({ connectivityStatusText, isConnected, isManuallyEdited, lastConnectedDate }) {
  if (!isConnected) {
    return <FormattedMessage id="services.Vehicles.vehicleDisconnected" />;
  } else if (isManuallyEdited) {
    return (
      <FormattedMessage
        id="services.Vehicles.manuallyEdited"
        values={{ refreshIcon: <i className="icon-refresh" /> }}
      />
    );
  } else if (!isNil(connectivityStatusText)) {
    return <MaybeTranslation renderedValue={connectivityStatusText} />;
  }
  return (
    <Fragment>
      <FormattedMessage id="services.Vehicles.vehicleConnected" />
      <br />
      <FormattedMessage id="services.Vehicles.lastUpdated" />{' '}
      {moment.duration(moment(lastConnectedDate).diff(moment())).humanize(true)}
    </Fragment>
  );
}

const ConnectedMetadata = (props) => {
  const { readOnly, ...rest } = props;

  if (!readOnly) {
    return (
      <ConnectedMetadataWrapper>
        <CarIcon {...rest} />
        <ConnectedMetadataText>
          <MetadataText {...rest} />
        </ConnectedMetadataText>
      </ConnectedMetadataWrapper>
    );
  }

  return null;
};

export default ConnectedMetadata;
